export default __webpack_public_path__ + "static/media/Ellipse 25.08cd9f8d.svg";